// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var Creative = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M5.337 8.994zl-.005-.015-.045-.145c-.045-.145-.08-.262-.112-.374C5.058 8.049 5 7.753 5 7.501c0-1.102 1.088-1.165 2.992-.603.808-.263 1.429-.397 1.883-.397.661 0 1.125.313 1.125.921 0 .251-.058.55-.175.968l-.07.243-.088.288-.005.017-.002.006-.183.596c-.162.537-.271.947-.351 1.344a5.7 5.7 0 0 0-.127 1.117.5.5 0 0 1-1 0c0-.404.051-.839.147-1.315.087-.433.204-.871.374-1.435.394-1.305.466-1.537.48-1.682l.003-.066-.001-.032-.006.012q-.012.011-.06.015l-.063.002c-.297 0-.76.094-1.375.285v1.321a.5.5 0 0 1-1 0v-1.31c-.607-.168-1.065-.246-1.359-.237-.116.004-.14-.006-.144-.024v.061l.002.044c.011.143.08.357.478 1.647.192.622.319 1.098.407 1.573q.114.607.115 1.141a.5.5 0 0 1-1 0q-.001-.435-.098-.958c-.08-.429-.197-.872-.379-1.46l-.18-.574-.003-.008-.002-.006z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8 2a5 5 0 1 0 .001 10.001A5 5 0 0 0 8 2m0-1a6 6 0 1 1 0 12A6 6 0 0 1 8 1"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10 12a.5.5 0 0 1 1 0v1a3 3 0 1 1-6 0v-1a.5.5 0 0 1 1 0v1a2 2 0 1 0 4 0zM.129.877A.5.5 0 1 1 .831.165l1.006.993a.5.5 0 1 1-.702.712zM15.132.049a.5.5 0 1 1 .708.706l-.996.998a.5.5 0 1 1-.708-.706zM1.926 13.747a.5.5 0 0 1-.707-.707l1.023-1.023a.5.5 0 0 1 .707.707zM15.139 13.13a.5.5 0 0 1-.707.707l-1-1a.5.5 0 0 1 .707-.707z"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(Creative);
export default ForwardRef;
